import { useMutation } from 'react-query';

import { binderManagementFileInputAxios } from '../../binderManagement.api';
import { useHandleError } from '../../binderManagement.utils';

export const useImportBDXMapping = () => {
  const handleError = useHandleError({
    file: 'binderManagement.bdx.mutation.useSubmitBDX',
    warning: 'notification.bdx.submitFail',
  });

  return useMutation(
    async ({ facilityFrom, bdxTypeFrom, facilityTo, bdxTypeTo, requestId, sheetName, rowId, fileFields }) => {
      const data = await binderManagementFileInputAxios.post('mapping', {
        facilityFrom,
        bdxTypeFrom,
        facilityTo,
        bdxTypeTo,
        requestId,
        sheetName,
        rowId,
        fileFields,
      });

      return data;
    },
    {
      onError: handleError,
    }
  );
};
